
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"13.5","fill":"#FFF","stroke":"#CFD8DC"}}),_c('path',{attrs:{"d":"M21 15a1 1 0 100-2H9.414l3.293-3.293a1 1 0 00-1.414-1.414l-5 5a.997.997 0 000 1.414l5 5a1 1 0 001.414-1.414L9.414 15H21z","fill":"currentColor"}})])
          )
        }
      }
    